/*
  MAISON 1822 — Copie des soumissions de formulaire vers Supabase.

  Le formulaire part normalement vers Shopify : ce script se contente d'envoyer
  une copie à la base avant le départ. Si la copie échoue, la demande arrive
  quand même par e-mail comme aujourd'hui.

  Depuis la v2, la liste « Ma sélection » est transmise de façon structurée
  (titre, variante, SKU, url) afin d'alimenter un devis dans Supabase, au lieu
  de n'exister que sous forme de texte libre dans le message.
*/
(function () {
  var ENDPOINT = 'https://adgaujemdhchptygrixl.supabase.co/functions/v1/form-intake';

  function collecte(form) {
    var champs = {};
    var data = new FormData(form);
    data.forEach(function (valeur, cle) {
      if (typeof valeur !== 'string') return;
      if (Object.prototype.hasOwnProperty.call(champs, cle)) {
        if (Array.isArray(champs[cle])) {
          champs[cle].push(valeur);
        } else {
          champs[cle] = [champs[cle], valeur];
        }
      } else {
        champs[cle] = valeur;
      }
    });
    return champs;
  }

  function selection() {
    try {
      if (window.QuoteList && typeof window.QuoteList.getAll === 'function') {
        return window.QuoteList.getAll() || [];
      }
    } catch (e) { /* silencieux */ }
    return [];
  }

  function envoyer(corps) {
    // text/plain evite le pre-vol CORS : la fonction lit le corps brut puis parse le JSON.
    var type = 'text/plain;charset=UTF-8';
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([corps], { type: type }));
        return;
      }
    } catch (e) { /* on retombe sur fetch */ }
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': type },
        body: corps,
        keepalive: true,
        mode: 'cors'
      });
    } catch (e) { /* silencieux : ne jamais gêner l'envoi du formulaire */ }
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/contact') === -1) return;

    var type = form.querySelector('input[name="form_type"]');
    if (type && type.value !== 'contact') return;

    try {
      var champs = collecte(form);
      if (!champs || Object.keys(champs).length === 0) return;

      var piege = form.querySelector('input[name="m1822_hp"]');

      envoyer(JSON.stringify({
        page: window.location.href,
        champs: champs,
        selection: selection(),
        hp: piege ? piege.value : ''
      }));
    } catch (e) { /* silencieux */ }
  }, true);
})();
